import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle as faCircleSolid } from '@fortawesome/free-solid-svg-icons';
import { faCircle } from '@fortawesome/free-regular-svg-icons';

import { AirtableDataConsumer, AirtableContextData } from '../core/AirtableDataProvider';

interface Props { }

export default class Testimonials extends React.Component<Props> {

  state = {
    selected: 0
  }

  render()
  {
    return (
      <AirtableDataConsumer>
        { data => data && this._render(data) }
      </AirtableDataConsumer>
    );
  }

  _render(data: AirtableContextData)
  {
    const records = data.airtable.testimonials;

    if (records.length === 0) {
      return null;
    }

    const current = records[this.state.selected];

    return (
      <div className="flex flex-row justify-center">
        <div className="wfull pv4">

          <div>
            <p className="gray lh-copy tc i f5 f4-ns ph3 ph6-l pv4 white theme--primary-background-color">
              " { current.Content } "
            </p>
            <p className="tc f5 ph3 lh-copy">
              <span>{ current.CustomerName }, { current.CustomerTitle }, </span>
              <a
                target="_blank" rel="noopener noreferrer"
                className="link dim black"
                href={ current.CompanyLink }>{ current.CompanyName }</a>
            </p>
          </div>

          <div className="tc mv3">
            { records.map((n, idx) =>
              <span key={ idx } onClick={ () => this.select(idx) } className="pointer ph2">
              { n === current ?
                <FontAwesomeIcon icon={ faCircleSolid } />
                : <FontAwesomeIcon icon={ faCircle } /> }
              </span>
            ) }
          </div>

        </div>

      </div>
    );
  }

  select(index: number)
  {
    this.setState({ selected: index });
  }

}